module.exports = __webpack_public_path__ + "img/jpm_icons3.77340fbf.svg";